import styled from "styled-components";
import Style from "types/globals/styleguide/style";

interface InputProps {
  color: string;
  borderBottomColor: string;
  textAlign?: string;
  disableBorder?: boolean;
}

const Input = styled.input<InputProps>`
  display: flex;
  width: 100%;
  height: 60px;
  margin: 0;
  color: ${({ color }) => color};
  background-color: transparent;
  outline: none;
  border: 0px;
  border-bottom: ${({ borderBottomColor, disableBorder }) =>
    disableBorder ? "" : "1px solid " + borderBottomColor};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "")};
  padding: 0;
`;

export default Input;
